"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This class is used to store data about a cache item that was not found.
 */
var CacheNotFoundItem =
/**
 * Class constructor.
 *
 * @param {String} key Cache key.
 */
function CacheNotFoundItem(key) {
  _classCallCheck(this, CacheNotFoundItem);

  this.key = key;
  this.isWaiting = false;
  this.isNotFound = true;
};

exports.default = CacheNotFoundItem;